// Elements don't share standard fields across clients so this finds the
// first available 'name/id-like' field in priority and returns the value,
// otherwise returns the supplied default.
const NAME_FIELD_PRIORITY = [
  /\bsite id\b/i,
  /\bsite name\b/i,
  /\baddress\b/i,
  /\baddress\(es\)\b/i,
  /\broad id\b/i,
  /\bname\b/i,
  /\bdescription\b/i,
  /\bstate highway\b/i,
  /\bnumber\b/i,
  /\btitle\b/i,
  /\bid\b/i,
  /\basset\b/i,
]

export const getElementName = (
  identifyingInformation: Record<string, unknown> | null | undefined,
  defaultIfNull = '',
): string => {
  if (!identifyingInformation) return defaultIfNull

  const keys = Object.keys(identifyingInformation)

  for (const pattern of NAME_FIELD_PRIORITY) {
    const matchedKey = keys.find((key) => pattern.test(key))
    if (matchedKey === undefined) continue

    const value = identifyingInformation[matchedKey]
    return value == null || value === '' ? defaultIfNull : String(value)
  }

  return defaultIfNull
}
